<section id="top-bar" [ngClass]="{ 'shadow-md border-b border-gray-200': isScrolled() }">
    <div class="flex flex-col gap-1">
        <div [attr.data-theme]="theme()" class="text-2xl font-bold theme-text">
            {{ header() }}
        </div>
        @if (description()) {
            <div [attr.data-theme]="theme()" class="flex text-sm description">
                {{ description() }}
            </div>
        }
    </div>
    <ng-container *ngTemplateOutlet="suffixSection" />
</section>

<ng-template #suffixSection>
    <div class="flex items-center gap-1">
        @if (admin(); as admin) {
            <app-button [cdkMenuTriggerFor]="menu" color="normal" variant="ghost">{{ admin.name }} 님</app-button>
        }
        <app-icon-button
            (click)="toggleTheme()"
            [icon]="theme() === 'dark' ? 'material-symbols-light:dark-mode-rounded' : 'ic:baseline-light-mode'"
        />
    </div>
</ng-template>

<ng-template #menu>
    <app-menu cdkMenu>
        <app-menu-option (click)="adminStore.logout()" cdkMenuItem>로그아웃</app-menu-option>
    </app-menu>
</ng-template>
